// Types
import {
    flexDirection,
    flexAlignItems,
    flexJustifyContent,
    flexAlignSelf,
    flexJustifySelf,
    flexWrap
} from '../types/Flex.types';

// Utils
import { EmptyOrEligibleProp } from '../utils/props-utils';

export default {
    props: {
        flexDirection: {
            type: String,
            default: '',
            validator: EmptyOrEligibleProp(flexDirection)
        },
        alignItems: {
            type: String,
            default: '',
            validator: EmptyOrEligibleProp(flexAlignItems)
        },
        justifyContent: {
            type: String,
            default: '',
            validator: EmptyOrEligibleProp(flexJustifyContent)
        },
        alignSelf: {
            type: String,
            default: '',
            validator: EmptyOrEligibleProp(flexAlignSelf)
        },
        justifySelf: {
            type: String,
            default: '',
            validator: EmptyOrEligibleProp(flexJustifySelf)
        },
        flexWrap: {
            type: String,
            default: '',
            validator: EmptyOrEligibleProp(flexWrap)
        }
    }
}
